export const login = {
  login: {
    title: "Log in to Access Sehahub",
    formFields: [
      {
        placeholder: "",
        name: "email",
        label: "Email",
        type: "Email",
        autocomplete: "off",
        className: "form-elemnt",
        inputSize: "large",
        nature: "input",
        itemclass: "",
        link: "",
      },
      {
        placeholder: "",
        name: "password",
        label: "Password",
        type: "password",
        autocomplete: "off",
        className: "form-elemnt",
        inputSize: "large",
        nature: "input",
        itemclass: "",
        link: "",
      },
      {
        placeholder: "",
        name: "Submit",
        label: "Login",
        type: "primary",
        autocomplete: "off",
        className: "submit-item",
        inputSize: "large",
        nature: "button",
        itemclass: "submit-btn",
        link: ""
      },
      {
        placeholder: "",
        name: "forgetpassword",
        label: "Need Help ?",
        type: "primary",
        autocomplete: "off",
        className: "submit-item",
        inputSize: "large",
        nature: "link",
        itemclass: "submit-btn",
        link: "https://ant.design",
      },
    ],
    extraContent:[
        {
            placeholder: "",
            name: "dontHaveAccount",
            label: "Don't have an account ?",
            type: "",
            autocomplete: "off",
            className: "Do-have-account",
            inputSize: "large",
            nature: "text",
            itemclass: "",
            link: "",
          },
          {
            placeholder: "",
            name: "submit",
            label: "Register Here",
            type: "primary",
            autocomplete: "off",
            className: "submit-item",
            inputSize: "large",
            nature: "input",
            itemclass: "submit-btn form-elemnt reg-btn",
            link: "",
          },
      ]
  },
  profile:{
    distributor:{
      2:{
        steptitle:"Contact Person",
        fields:[
          {
            label:"First Name",
            type:"Text"
          }
        ]

      }
    }
  }
  
};
